import apiUtils from '@elab/core/utils/apiUtils';

import HTTPClient from '../../utils/HTTPClient';

const getApiService = () => `${apiUtils.getBaseUri()}/products`;

const getProductsPath = (ids) => `${getApiService()}/?codes=${ids}&fields=DEFAULT`;
const getIdsParam = (ids = [], separator = ',', prefix = '') => {
    return ids.flat().reduce((acc, id) => (acc ? `${acc}${separator}${id}` : `${prefix}${id}`), '');
};

export const loadProduct = async productCode => {
    const uri = `${getApiService()}/${productCode}?fields=FULL`;
    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load product (${response.status})`);
    }
    return await response.json();
};

export const getReferences = async (productCode, referenceType) => {
    const endpoint = `${getApiService()}/${productCode}/references?fields=DEFAULT&referenceType=${referenceType}`;
    const response = await HTTPClient().get(endpoint);
    if (!response.ok) {
        throw new Error(`Unable to load product matrix (${response.status})`);
    }
    return await response.json();
};

export const getProductsByIds = async (ids = []) => {
    const idsParam = getIdsParam(ids);
    const uri = getProductsPath(idsParam);
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to load products (${response.status})`);
    }
    return await response.json();
};

export const getNewItemsHTML = async (page, queryString) => {
    const searchParams = new URLSearchParams(queryString);
    searchParams.set('page', page);
    const url = `${window.location.pathname}?${searchParams.toString()}`;
    const response = await HTTPClient().get(url);
    return await response;
};

export const loadProductVariant = async variantCode => {
    const endpoint = `${getApiService()}/${variantCode}?fields=VARIANT_SELECTOR`;
    const response = await HTTPClient().get(endpoint);

    if (!response.ok) {
        throw new Error(`Unable to load product variant (${response.status})`);
    }
    return await response.json();
};

export const loadProductVariantMatrix = async variantCode => {
    const endpoint = `${getApiService()}/${variantCode}?fields=VARIANT_MATRIX`;
    const response = await HTTPClient().get(endpoint);

    if (!response.ok) {
        throw new Error(`Unable to load product matrix (${response.status})`);
    }
    return await response.json();
};

export const getProductHomeDeliveryDate = async (deliveryMode, productCode) => {
    const baseUri = `${apiUtils.getBaseUri()}/deliverymodes/${deliveryMode}/estimation`;
    const params = `?fields=FULL&productCode=${productCode}`;
    const uri = `${baseUri}${params}`;

    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        const responseJSON = await response.json();
        const errors = responseJSON.errors && responseJSON.errors[0];

        throw new Error(errors.errorCode);
    }

    return await response.json();
};

export const getProductPickupInStoreDeliveryDate = async (
    deliveryMode,
    productCode,
    latitude = 0,
    longitude = 0,
) => {
    const baseUri = `${apiUtils.getBaseUri()}/deliverymodes/${deliveryMode}/estimation/store/`;
    const params = `?fields=FULL&productCode=${productCode}&latitude=${latitude}&longitude=${longitude}`;
    const uri = `${baseUri}${params}`;

    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        const responseJSON = await response.json();
        const errors = responseJSON.errors && responseJSON.errors[0];

        throw new Error(errors.errorCode);
    }

    return await response.json();
};

export default {
    loadProduct,
    loadProductVariant,
    loadProductVariantMatrix,
    getNewItemsHTML,
    getProductHomeDeliveryDate,
    getProductPickupInStoreDeliveryDate,
    getReferences,
    getProductsByIds,
};
